import { Dimensions } from "react-native";
import { toast } from "react-toastify";
import { dynamicWebUrl } from "../Api/configs";

export const screenWidth = Dimensions.get("window").width;
export const screenHeight = Dimensions.get("window").height;

export const regex = new RegExp(
  `^${dynamicWebUrl.replace(
    /[.*+?^${}()|[\]\\]/g,
    "\\$&"
  )}\\/notifications\\?ID=\\w+$`
);
export const regexForSuccess = new RegExp(
  `^${dynamicWebUrl.replace(
    /[.*+?^${}()|[\]\\]/g,
    "\\$&"
  )}\\/success\\?session_id=\\w+$`
);

export const urlStart = `${dynamicWebUrl}/notifications?ID=`;
export const urlStartLocal = `${dynamicWebUrl}/notifications?ID=`;
export const urlEventDetailShare = `${dynamicWebUrl}/ticket-detail?eventID=`;
export const regularEventDetail = `${dynamicWebUrl}/ticket-detail?eventID=`;
export const upcomingEventDetail = `${dynamicWebUrl}/events/game-show?eventID=`;
export const notificationShareUrl = `${dynamicWebUrl}/notifications?ID=`;
export const notificationShareInvite = `${dynamicWebUrl}/notifications`;
export const siteDevelopmentUrl = dynamicWebUrl;
export const chatUrl = `${dynamicWebUrl}/messages`;
export const developUrl = dynamicWebUrl;
export const NotificationUrl = `${dynamicWebUrl}/notifications`;

// Allowed email domains for registration
const allowedEmailDomains = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.fr",
  "yahoo.co.uk",
  "yahoo.com.br",
  "yahoo.co.in",
  "yahoo.es",
  "yahoo.it",
  "yahoo.de",
  "yahoo.ca",
  "yahoo.com.au",
  "yahoo.com.ar",
  "yahoo.com.mx",
  "yahoo.co.jp",
  "yahoo.in",
  "ymail.com",
  "rocketmail.com",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "hotmail.it",
  "hotmail.es",
  "hotmail.de",
  "msn.com",
  "live.com",
  "live.fr",
  "live.co.uk",
  "live.nl",
  "outlook.com",
  "sbcglobal.net",
  "aol.com",
  "icloud.com",
  "me.com",
  "comcast.net",
  "orange.fr",
  "wanadoo.fr",
  "neuf.fr",
  "sfr.fr",
  "voila.fr",
  "aliceadsl.fr",
  "rediffmail.com",
  "free.fr",
  "gmx.de",
  "web.de",
  "gmx.net",
  "gmx.com",
  "yandex.ru",
  "libero.it",
  "alice.it",
  "virgilio.it",
  "tiscali.it",
  "uol.com.br",
  "bol.com.br",
  "ig.com.br",
  "terra.com.br",
  "mail.ru",
  "rambler.ru",
  "cox.net",
  "att.net",
  "charter.net",
  "bellsouth.net",
  "verizon.net",
  "earthlink.net",
  "optonline.net",
  "laposte.net",
  "facebook.com",
  "bigpond.com",
  "tiscali.co.uk",
  "shaw.ca",
  "t-online.de",
  "freenet.de",
  "telenet.be",
  "home.nl",
  "planet.nl",
  "qq.com",
  "163.com",
  "126.com",
  "sky.com",
  "protonmail.com",
  "proton.me",
  "zoho.com",
  "mail.com",
  "inbox.com",
  "fastmail.com",
  "tutanota.com",
];

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validateEmailDomain = (email) => {
  // First check if email format is valid
  if (!validateEmail(email)) {
    return false;
  }

  // Extract domain from email
  const domain = String(email).toLowerCase().split("@")[1];
  // Check if domain is in allowed list
  return allowedEmailDomains.includes(domain);
};
export const validateUsername = (username) => {
  return /^[a-z0-9_]+$/.test(username);
};
export const formatDate = (dateString) => {
  const today = new Date();
  const inputDate = new Date(dateString);

  // Check if the date is today
  if (
    inputDate.getDate() === today.getDate() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear()
  ) {
    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    // @ts-ignore
    return `Today ${inputDate.toLocaleTimeString(undefined, options)}`;
  }

  // Check if the date is tomorrow
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  if (
    inputDate.getDate() === tomorrow.getDate() &&
    inputDate.getMonth() === tomorrow.getMonth() &&
    inputDate.getFullYear() === tomorrow.getFullYear()
  ) {
    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    // @ts-ignore
    return `Tomorrow ${inputDate.toLocaleTimeString(undefined, options)}`;
  }

  // Format the date as dd/mm/yyyy hh:mm AM/PM
  const dateTimeOptions = {
    day: "2-digit",
    month: "short",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  // @ts-ignore
  return inputDate.toLocaleDateString(undefined, dateTimeOptions);
};

export const getDateDiffereceInMinutes = (startDateTime, endDateTime) => {
  const startDate = new Date(startDateTime);
  const endDate = new Date(endDateTime);

  const differenceInMilliseconds = endDate.getTime() - startDate.getTime();
  const differenceInMinutes = differenceInMilliseconds / 1000 / 60;

  return differenceInMinutes;
};

export const showToast = (message: string) => {
  toast.success(message, {
    //@ts-ignore
    placement: "center",
    duration: 1000,
    animationType: "slide-in",
  });
};
